import { styled } from "styled-components";

import type { ActivationAlertsContractSocialAdPlatform } from "@similarweb/pro-api-client";
import { colorsPalettes, setElevation } from "@similarweb/styles";
import { Tooltip } from "@similarweb/ui-components";
import { Flex } from "@similarweb/ui-components/foundations";

import { ChannelIcon } from "../../../common/ChannelIcon";
import { getPlatformName } from "../../utils/getPlatformName";

const ICON_SIZE = 20;
const OVERLAP = 3;

const IconWrapper = styled(Flex)<{ $hasOffset: boolean }>`
    width: ${ICON_SIZE}px;
    height: ${ICON_SIZE}px;
    border-radius: 3px;
    border: 1px solid ${colorsPalettes.carbon[50]};
    background: ${colorsPalettes.carbon[0]};
    ${setElevation("Z1")}
    align-items: center;
    justify-content: center;
    ${({ $hasOffset }) => ($hasOffset ? `margin-left: -${OVERLAP}px;` : "")}
    position: relative;
    flex-shrink: 0;
`;

type PlatformIconStackProps = {
    platforms: ActivationAlertsContractSocialAdPlatform[];
};

export const PlatformIconStack = ({ platforms }: PlatformIconStackProps) => (
    <Flex alignItems="center">
        {platforms.map((platform, index) => (
            <Tooltip
                key={platform}
                content={getPlatformName(platform)}
            >
                <IconWrapper $hasOffset={index > 0}>
                    <ChannelIcon
                        channel={platform}
                        size={14}
                    />
                </IconWrapper>
            </Tooltip>
        ))}
    </Flex>
);
